import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Leaf, HeartHandshake, Truck } from 'lucide-react';
export function CTASection() {
  return <section className="w-full px-4 py-16 max-w-3xl mx-auto text-center space-y-10" data-id="element-14">
      {/* Trust Bar */}
      <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-serif text-brown/80 mb-12" data-id="element-15">
        <div className="flex items-center gap-2" data-id="element-16">
          <HeartHandshake size={18} className="text-forest" data-id="element-17" />
          <span data-id="element-18">80.000+ zufriedene Kunden</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-19">
          <ShieldCheck size={18} className="text-forest" data-id="element-20" />
          <span data-id="element-21">Von Tierärzten empfohlen</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-22">
          <Leaf size={18} className="text-forest" data-id="element-23" />
          <span data-id="element-24">100% pflanzlich & natürlich</span>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-forest text-cream p-8 md:p-12 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-25">
        <div className="relative z-10 space-y-6" data-id="element-26">
          <h2 className="font-handwriting text-4xl md:text-5xl font-bold" data-id="element-27">
            Gib deinem Hund seinen Darm zurück
          </h2>

          <p className="font-serif text-lg md:text-xl text-cream/90 max-w-xl mx-auto" data-id="element-28">
            Natürlicher Wiederaufbau der Darmflora – risikofrei testen mit
            Geld-zurück-Garantie.
          </p>

          <a href="https://hunderunde.shop/products/futtertopping-magen-darm" target="_blank" rel="noopener noreferrer" className="inline-block mt-4 bg-cream text-forest font-serif font-bold text-lg md:text-xl px-8 py-4 rounded-full shadow-lg hover:scale-105 hover:bg-white transition-all duration-300" data-id="element-29">
            Jetzt für meinen Hund entdecken →
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 pt-6 text-sm font-serif text-cream/80" data-id="element-30">
            <span className="flex items-center gap-1" data-id="element-31">
              <Truck size={16} data-id="element-32" /> Schneller Versand
            </span>
            <span className="flex items-center gap-1" data-id="element-33">
              <ShieldCheck size={16} data-id="element-34" /> Zufriedenheitsgarantie
            </span>
            <span className="flex items-center gap-1" data-id="element-35">
              <Leaf size={16} data-id="element-36" /> 100% Natürliche Inhaltsstoffe
            </span>
          </div>
        </div>

        {/* Decorative background circle */}
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl" data-id="element-37"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-black opacity-10 rounded-full blur-3xl" data-id="element-38"></div>
      </motion.div>
    </section>;
}